import { compose, get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { globalizationSelector as moduleSelector } from '@mews/globalization';
import { getStringProp } from '@mews/fp';
import { getOrEmptyObject } from '@mews-commander/utils';

export const getAccountingEnvironments = compose(getOrEmptyObject('accountingEnvironments'), moduleSelector);

export const getAccountingEnvironmentByCode = createSelector(getStringProp('code'), getAccountingEnvironments, get);
